import * as server from '../../../Axios'

export const getPorcentajesSalEnt = async q => {
  return await server
    .getPorcentajesSalEnt(q)
    .then(response => ({ data: response.data }))
    .catch(error => ({ error: error }))
}
